<form #form="ngForm"
      method="post"
      id="form">
    @if (basket.qty) {
    <div class="wrap p-b-12 p-b-3-s p-b-3-m p-t-4"
         bottomPanelArea="basketButton"
         cy-basketView
         *ifSize="'SM'">
        <go-back />
        <div class="m-t-9">
            <h1 class="h3 inline-block va-m">{{'Basket' | translate}}</h1>
            <div class="p2 col-12 inline-block m-l-3 va-m">
                {{ (basket.qty === 1 ? '% item' : '% items') | translate : basket.qty }}
            </div>
        </div>
        <span class="p2 col-11 m-t-1 m-b-1 block"
              *iCms="'basketStockMessaging' of content; skipEmpty: true"
              text></span>

        @if (content?.showEuRegulationsMessage) {
        <div class="p-t-3 p-b-3 m-b m-t center"
             [ngStyle]="{'background-color': content?.bgColorTextBlocks || ''}">
            <span class="p2"
                  *iCms="'euRegulationsMessage' of content; content: 'html'"></span>
        </div>
        }

        @if (basket.items.length > 1) {
        <div class="p-t-3 p-b-3 m-b-4 m-t-4 center"
             [ngStyle]="{'background-color': content.bgColorTextBlocks || ''}">
            <span class="p2"
                  *iCms="'basketMessage' of content"
                  text></span>
        </div>
        }
        <basket-free-shipping class="m-t-6 block" />
        <div class="m-t-5"></div>
        @for (item of basket.items; track item.id) {
        <div [ngClass]="{'p-b': item.product.data.isProductProtectionPlan || item.product.data.isAssembly}"
             [class.b-t]="!$first && !(item.product.data.isProductProtectionPlan || item.product.data.isAssembly)">
            @if (!!item?.product?.data?.isProductProtectionPlan || !!item.product.data.isAssembly) {
            <protection-plans-item [product]="item.product"
                                   [item]="item">
                <!-- BKR-3262: IPID checkbox hidden -->
                <!-- @if (!!item?.product?.data?.isProductProtectionPlan) {
                <ng-template #protectionPlansCheckbox>
                    <input-wrap class="w-12 m-t-3"
                                [required]="true"
                                [messages]="{required: 'You must read and accept the terms and conditions to continue'}">
                        <checkbox class="w-12 p-t-2 p-r p-b-2 p-l bg-col-6 col-w _protection-plan-checkbox"
                                  name="isProtectionPlanChecked{{$index}}"
                                  [notCheckedValue]="undefined"
                                  [(ngModel)]="protectionPlanAgreements[item.product.data.id]"
                                  required>
                            <p [sizeClass]="'SM: c2, XL: c1'">
                                {{'I have read and I accept the' | translate }}&nbsp;<a class="underline"
                                   (click)="openPdf('assets/pdf/updated-ipid.pdf')">{{'Protection Plan terms and
                                    conditions' | translate}}</a>
                            </p>
                        </checkbox>
                    </input-wrap>
                </ng-template>
                } -->
            </protection-plans-item>
            } @else {
            <basket-view-item class="block m-t p-b"
                              [item]="item"
                              cy-basketProd />
            }
        </div>
        }
        <furniture-assembly class="block" />
        <basket-view-totals [context]="'basket'"
                            class="block m-t-5 m-t-9-s m-t-9-m" />
        @if ((basket.totals?.subtotal || 0) >= 500) {
        <v12-retail-finance-from-basket class="m-t-6 block"
                                        [amount]="basket.totals.grand_total" />
        }
        <ng-container *abIf="'(basketPromoCode) !B'">
            <basket-view-coupon-form class="block m-t-6" />
        </ng-container>
        <protection-plans />
        <ng-container *abIf="'(basketPromoCode) B'">
            <basket-view-coupon-form class="block m-t-6" />
        </ng-container>
        <ng-container *abIf="'(expressButtons) B'">
            <ng-container *ifApplePayAvailable>
                <barclaycard-apple-pay-express class="block m-t"></barclaycard-apple-pay-express>
            </ng-container>
            <paypal-express-button *ngIf="basket.isSalable"
                                   class="w-12 m-t pos-relative z-0"></paypal-express-button>
            <div class="w-12 center">{{ 'Or' | translate }}</div>
        </ng-container>
        <basket-view-submit class="block m-t"
                            [form]="form" />
        <basket-view-pay-with class="block m-t center"
                              [paymentMethods]="content.payment_method_icons" />
    </div>
    <div class="bg-col-51 p-t-9"
         cy-basketView
         *ifSize="'XL'">
        <div class="c-1"></div>
        <div class="c-6 bg-col-w p-a-9">
            <div class="flex flex-middle flex-justify-between">
                <div>
                    <h1 class="h3 inline-block va-m">{{'Basket' | translate}}</h1>
                    <div class="p1 col-11 m-l-4 inline-block va-m">
                        {{ (basket.qty === 1 ? '% item' : '% items') | translate : basket.qty }}
                    </div>
                </div>
                <span class="p2 col-11 block"
                      *iCms="'basketStockMessaging' of content; skipEmpty: true"
                      text></span>
            </div>
            @if (content.showEuRegulationsMessage) {
            <div [ngStyle]="{'background-color': content.bgColorTextBlocks || ''}"
                 class="p-t-3 p-b-3 m-b-4 m-t-4 center">
                <span class="p1"
                      *iCms="'euRegulationsMessage' of content; content: 'html'"></span>
            </div>
            }
            @if (basket.items.length > 1) {
            <div [ngStyle]="{'background-color': content.bgColorTextBlocks || ''}"
                 class="p-t-3 p-b-3 p-l-12 p-r-12 m-b-4 m-t-4 center">
                <span class="inline-block p1 p-l-2 p-r-2"
                      *iCms="'basketMessage' of content"
                      text></span>
            </div>
            }
            <basket-free-shipping class="m-t block" />
            @for (item of basket.items; track item.id) {
            <div [ngClass]="{'p-b': item.product.data.isProductProtectionPlan || item.product.data.isAssembly}"
                 [class.b-t]="!$first && !(item.product.data.isProductProtectionPlan || item.product.data.isAssembly)">
                @if (!!item?.product?.data?.isProductProtectionPlan || !!item.product.data.isAssembly) {
                <protection-plans-item [product]="item.product"
                                       [item]="item">
                    <!-- BKR-3262: IPID checkbox hidden -->
                    <!-- @if (!!item?.product?.data?.isProductProtectionPlan) {
                    <ng-template #protectionPlansCheckbox>
                        <input-wrap class="w-12 m-t-3"
                                    [required]="true"
                                    [messages]="{required: 'You must read and accept the terms and conditions to continue'}">
                            <checkbox class="w-12 p-t-2 p-r p-b-2 p-l bg-col-6 col-w _protection-plan-checkbox"
                                      name="isProtectionPlanChecked{{$index}}"
                                      [notCheckedValue]="undefined"
                                      [(ngModel)]="protectionPlanAgreements[item.product.data.id]"
                                      required>
                                <p class="c1">
                                    {{'I have read and I accept the ' | translate }}
                                    <a class="underline"
                                       (click)="openPdf('assets/pdf/updated-ipid.pdf')">
                                        {{'Protection Plan terms and conditions' | translate}}</a>
                                </p>
                            </checkbox>
                        </input-wrap>
                    </ng-template>
                    } -->
                </protection-plans-item>
                } @else {
                <basket-view-item class="block m-t p-b"
                                  [item]="item"
                                  cy-basketProd />
                }
            </div>
            }
            <furniture-assembly class="block" />
        </div>
        <div class="c-4"
             [stickyPanel]="app.client?.sizeId > 1"
             [stickyPanelOffsetTop]="100">
            <div class=" p-t-9 p-b-9 p-l-6 p-r-6 bg-col-w">
                <h2 class="h3">{{'Order summary' | translate}}</h2>
                <basket-view-totals [context]="'basket'"
                                    class="block m-t-6" />
                <ng-container *abIf="'(basketPromoCode) !B'">
                    <basket-view-coupon-form class="block m-t m-b-3" />
                </ng-container>

                @if (basket.totals?.subtotal >= 500) {
                <v12-retail-finance-from-basket class="m-t-4 block"
                                                [amount]="basket.totals.grand_total"
                                                *abIf="'(v12RetailFinance) A'" />
                }

                <protection-plans class="w-12" />

                <paypal-express-button *ngIf="basket.isSalable"
                                       class="w-12 m-t pos-relative z-0" />
                <paypal-pay-in-three-message class="block m-t-2"
                                             [mode]="'basket'"
                                             [amount]="basket.totals?.grand_total.toFixed(2)" />
                <div class="w-12 center">{{ 'Or' | translate }}</div>
                <basket-view-submit class="block m-t"
                                    [form]="form" />
                <basket-view-pay-with class="block m-t center"
                                      [paymentMethods]="content.payment_method_icons" />
                <ng-container *abIf="'(basketPromoCode) B'">
                    <basket-view-coupon-form class="block m-t-6" />
                </ng-container>
            </div>
            @if (content.sideImage || content.sideCopy) {
            <div class="center m-t-6">
                <div class="w-6">
                    <div [ngClass]="content.sideImageRatio || ratio-1-1">
                        <img [image]="content.sideImage"
                             class="rf">
                    </div>
                    <p *iCms="'sideCopy' of content; skipEmpty: true"
                       class="m-t"
                       text></p>
                </div>
            </div>
            }
        </div>
    </div>
    <div class="wrap-s wrap-m bg-col-51 bg-col-w-s bg-col-w-m flex flex-justify-center">
        <div class="w-10-x w-10-l w-12 ">
            <icms-outlet [components]=" content.bottomComponents"
                         [allow]="['upsell-product-carousel-layout']">
            </icms-outlet>
        </div>
    </div>
    }
    @if (!basket.qty) {
    <div style="min-height: 600px;"
         class="bg-col-51-x bg-col-51-l">
        <div class="wrap p-b-3-s p-b-3-m p-t-4"
             *ifSize="'SM'">
            <div class="m-t-9">
                <h1 class="h3 inline-block va-m">{{'Basket' | translate}}</h1>
            </div>
            <div class="center m-t">
                <span>{{'Your basket is empty' | translate}}</span>
            </div>
            <div class="center m-t">
                <a [routerLink]="'/' | lastCategoryPath"
                   class="button">{{'Continue shopping' | translate}}</a>
            </div>
        </div>
        <div class="p-t-9"
             cy-basketView
             *ifSize="'XL'">
            <div class="c-1"></div>
            <div class="c-10 p-a-9">
                <div>
                    <h1 class="h3 inline-block va-m">{{'Basket' | translate}}</h1>
                </div>
                <div class="m-t-6 ta-center">
                    <p class="p2">{{'Your basket is empty' | translate}}</p>
                    <div class="m-t">
                        <a [routerLink]="'/' | lastCategoryPath"
                           class="button">{{'Continue shopping' | translate}}</a>
                    </div>
                </div>
            </div>
        </div>
        <icms-outlet [components]=" content.emptyComponents">
        </icms-outlet>
    </div>
    }

</form>